export default __webpack_public_path__ + "0dbba0c2b7c4ca7b04ef618e68a411e4.png";